const Footer = () => {
    const handleClick = () => {
        return;
        document.documentElement.classList.remove("tanoga");
        document.documentElement.classList.add("tanesw");
    };
    return (
        <footer className="h-[200px] p-4 flex items-end justify-between" onClick={handleClick}>
            {/* {!process.env.REACT_APP_SYSTEM ? ( */}
            <span>Copyright © 2026 One Stop Center. All rights reserved.</span>
            {/* ) : (
                <span>
                    {process.env.REACT_APP_SYSTEM_NAME} | 2025 © {process.env.REACT_APP_FOOTER}
                </span>
            )} */}
        </footer>
    );
};

export default Footer;
